import { render, staticRenderFns } from "./GoGeo.vue?vue&type=template&id=0be74a28&scoped=true"
import script from "./GoGeo.vue?vue&type=script&lang=js"
export * from "./GoGeo.vue?vue&type=script&lang=js"
import style0 from "./GoGeo.vue?vue&type=style&index=0&id=0be74a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be74a28",
  null
  
)

export default component.exports